export class SearchDataConstants {
  static readonly MPID_SEARCH = 'mpidSearch';
  static readonly MPID_STATE = 'mpidState';
  static readonly SYS_SWITCH_METER_SEARCH = 'sysSwitchMeterSearch';
  static readonly SYS_SWITCH_CLEARING_SEARCH_FILTER = 'sysSwitchClearingSearchFilter';
  static readonly WORKLIST_SEARCH_FILTER = 'worklistSearchFilter';
  static readonly MESSAGE_MONITOR_SEARCH_FILTER = 'messageMonitorSearchFilter';
}
